import React from 'react';
import { css } from '@emotion/react';

export type LearnerTakeawayView = 'playful' | 'professional';

type ViewToggleProps = {
  value: LearnerTakeawayView;
  onChange: (view: LearnerTakeawayView) => void;
  /** 'dark' for the navy playful topbar, 'light' for the professional topbar. */
  variant?: 'dark' | 'light';
};

const styles = (variant: 'dark' | 'light') => {
  const isDark = variant === 'dark';
  const trackBg = isDark ? 'rgba(255,255,255,0.12)' : '#eef1f7';
  const idleColor = isDark ? 'rgba(255,255,255,0.7)' : '#6b7280';
  const activeBg = isDark ? '#ffffff' : '#1457d9';
  const activeColor = isDark ? '#14123A' : '#ffffff';
  return css`
    display: inline-flex;
    gap: 2px;
    padding: 3px;
    border-radius: 999px;
    background: ${trackBg};

    button {
      border: none;
      cursor: pointer;
      background: transparent;
      color: ${idleColor};
      font: inherit;
      font-size: 13px;
      font-weight: 600;
      padding: 6px 14px;
      border-radius: 999px;
      line-height: 1.2;
    }
    button.is-active {
      background: ${activeBg};
      color: ${activeColor};
    }
  `;
};

/** Segmented control to switch between the playful and professional report views. */
const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange, variant = 'dark' }) => (
  <div css={styles(variant)} role='group' aria-label='Report style'>
    <button
      type='button'
      className={value === 'playful' ? 'is-active' : ''}
      aria-pressed={value === 'playful'}
      onClick={() => onChange('playful')}
    >
      Playful
    </button>
    <button
      type='button'
      className={value === 'professional' ? 'is-active' : ''}
      aria-pressed={value === 'professional'}
      onClick={() => onChange('professional')}
    >
      Professional
    </button>
  </div>
);

export default ViewToggle;
